import produce from 'immer';
import { ICompatibilityReport } from '../api/models/compatibilityReport/compatibilityReport.types';
import { ECompatibilityReportType } from '../api/models/member/member.types';
import { initialRootState } from '../initialRootState';
import {
  ECompatibilityReportActionType,
  ICompatibilityReportAction,
} from './actions';

export interface ICompatibilityReportState {
  entries: {
    [accountId: string]: Partial<
      Record<ECompatibilityReportType, ICompatibilityReport>
    >;
  };
}

export const compatibilityReportReducer = (
  currentState: ICompatibilityReportState = initialRootState.compatibilityReport,
  action: ICompatibilityReportAction
): ICompatibilityReportState =>
  produce(currentState, draft => {
    switch (action.type) {
      case ECompatibilityReportActionType.GET_SUCCESS:
        const { accountId, reportType, compatibilityReport } = action.payload;

        draft.entries[accountId] = {
          ...(draft.entries[accountId] || {}),
          [reportType]: compatibilityReport,
        };
        break;
    }
  });
